export * from './game_card';
export type { GameCardProps } from './game_card';
